import React, { Component } from 'react'
import { bool, func, string } from 'prop-types'

import SearchBoxMobile from 'views/components/organisms/SearchBox/SearchBoxMobile'

import SearchHistoryService from 'views/assets/scripts/services/storage/SearchHistoryService'

class SearchBoxContainerMobile extends Component {
  state = {
    searchHistory: null
  }

  componentDidMount = () => {
    if (SearchHistoryService.isEnabled) {
      const searchHistory = SearchHistoryService.get()
      this.setState({
        searchHistory
      })
    }
  }

  addToHistory = query => {
    if (SearchHistoryService.isEnabled) {
      const searchHistory = SearchHistoryService.add(query)
      this.setState({
        searchHistory
      })
    }
  }

  clearHistory = () => {
    if (SearchHistoryService.isEnabled) {
      const searchHistory = SearchHistoryService.clear()
      this.setState({
        searchHistory
      })
    }
  }

  handleClearHistory = () => this.clearHistory()

  handleShowAll = event => {
    const { query } = this.props
    this.addToHistory(query)
    this.props.handleShowAll(event)
  }

  handleItemClick = event => {
    const { query, handleItemClick } = this.props
    this.addToHistory(query)

    if (handleItemClick) {
      handleItemClick(event)
    }
  }

  handleQueryUpdate = query => {
    if (this.props.handleQueryUpdate) {
      this.props.handleQueryUpdate(query)
    }
  }

  render() {
    const { searchHistory } = this.state

    const { displayResults } = this.props

    const displayHistory =
      !displayResults && searchHistory && searchHistory.length > 0

    return (
      <SearchBoxMobile
        {...this.props}
        displayHistory={displayHistory}
        searchHistory={searchHistory}
        handleQueryUpdate={this.handleQueryUpdate}
        handleClearHistory={this.handleClearHistory}
        handleShowAll={this.handleShowAll}
        handleItemClick={this.handleItemClick}
      />
    )
  }
}

SearchBoxContainerMobile.propTypes = {
  ...SearchBoxMobile.propTypes,
  query: string,
  displayResults: bool,
  handleQueryUpdate: func.isRequired,
  handleItemClick: func.isRequired
}

SearchBoxContainerMobile.defaultProps = {
  ...SearchBoxMobile.defaultProps,
  query: null,
  displayResults: false
}

export default SearchBoxContainerMobile
